import { Component, Input } from '@angular/core';

@Component({
  selector: 'muni-gameday-loading',
  templateUrl: './loading.template.html',
  styleUrls: ['./loading.styles.scss'],
  standalone: false,
})
export class LoadingComponent {
  @Input()
  public visible: boolean;
  @Input()
  public renderContent = false;
}
